import { render, staticRenderFns } from "./PayoutConfigModal.vue?vue&type=template&id=8332e42c&scoped=true"
import script from "./PayoutConfigModal.vue?vue&type=script&lang=js"
export * from "./PayoutConfigModal.vue?vue&type=script&lang=js"
import style0 from "./PayoutConfigModal.vue?vue&type=style&index=0&id=8332e42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8332e42c",
  null
  
)

export default component.exports